import React, {useEffect, useState} from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import DeskeraLogo from "src/assets/deskera.png";
import axios from "axios";

function post(path, params, method = "post") {
  const form = document.createElement("form");
  form.method = method;
  form.action = path;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

function App() {
  const [activeTenant, setActiveTenant] = useState(null);
  const [tenantOptions, setTenantOptions] = useState({});
  const [statusLoading, setStatusLoading] = useState(true);
  const [error, setError] = useState("");
  const [authParams, setAuthParams] = useState({});
  const [tenantLoading, setTenantLoading] = useState(false);
  const [tenantError, setTenantError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const currentURL = new URL(window.location);
  const clientId = currentURL.searchParams.get("client_id");

  async function handleTenantChange(e) {
    e.preventDefault();
    setTenantLoading(true);
    setTenantError("");
    const newTenantId = e.currentTarget.value;
    try {
      await axios.post(process.env.REACT_APP_SWITCH_TENANT_URL, {tenantId: newTenantId}, {withCredentials: true});
      setActiveTenant(tenantOptions[newTenantId]);
      // delete all cookies, set new cookies
    } catch (error) {
      setTenantError("Failed to switch tenants");
    } finally {
      setTenantLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    post(process.env.REACT_APP_OAUTH_AUTHORIZE_URL, authParams);
  }

  async function getLoginStatus(flag) {
    setStatusLoading(true);
    try {
      await axios.get(process.env.REACT_APP_LOGIN_STATUS_URL, {withCredentials: true});
      // uncomment following line only for local development
      // document.cookie = "x-access-token=" + res.data.idToken + ";";

      try {
        if (clientId === process.env.REACT_APP_CLERK_CLIENT_ID) {
          const authParams = {
            client_id: clientId,
            response_type: currentURL.searchParams.get("response_type"),
            scope: currentURL.searchParams.get("scope"),
            state: currentURL.searchParams.get("state")
          };
          post(process.env.REACT_APP_OAUTH_AUTHORIZE_URL, authParams);
          return;
        }

        const res = await axios.get(process.env.REACT_APP_GET_TENANT_URL,
            {withCredentials: true});
        if (!flag) {
          setActiveTenant(res.data[0]);
        }
        res.data.forEach((tenant, index) => {
          setTenantOptions(tenantOptions => ({...tenantOptions, [tenant.tenantId]: tenant}));
        });
      } catch (error) {
        setError("Failed to load tenants");
      }
      setStatusLoading(false);
    } catch (error) {
      let authURL = new URL(process.env.REACT_APP_AUTH_URL);
      authURL.searchParams.set("redirectUrl", window.location);
      window.location = authURL;
    }
  }

  useEffect(() => {
    getLoginStatus(currentURL.searchParams.has('placeholder'));
    // we parse the URL and intialize the parameters to be sent to the oauth server
    setAuthParams({
      client_id: clientId,
      response_type: currentURL.searchParams.get("response_type"),
      scope: currentURL.searchParams.get("scope"),
      state: currentURL.searchParams.get("state")
    });

    // eslint-disable-next-line
  }, []);

  return (
    <div class='bg-white' style={{height: "100vh", width: "100vw"}}>
      {statusLoading || clientId === process.env.REACT_APP_CLERK_CLIENT_ID ? (
        <div class='w-100 d-flex align-items-center justify-content-center' style={{height: "100%"}}>
          <div class='spinner-border' role='status'></div>
        </div>
      ) : (
        <div class='container d-flex align-items-center justify-content-center' style={{height: "100%"}}>
          <div
            class='w-100 p-5 text-center bg-white shadow-lg'
            style={{maxWidth: 500, margin: "auto", borderRadius: 16}}>
            <div class='mb-2' style={{height: 60}}>
              <img src={DeskeraLogo} style={{height:100}} alt="Deskera"/>
            </div>
            <h4 class='mb-4'>Connect Your Account</h4>
            <div class='form-group mb-4' placeholder='Select Account to Connect'>
              <select
                class='custom-select'
                name='tenant'
                value={activeTenant ? activeTenant.tenantId : ""}
                onChange={handleTenantChange}>
                <option selected>Select Organization</option>
                {Object.keys(tenantOptions).map(tenantId => (
                  <option value={tenantId}>{tenantOptions[tenantId].tenantName}</option>
                ))}
              </select>
            </div>
            {tenantError && <div class='alert alert-danger'>{tenantError}</div>}
            <>
              <button
                class='btn btn-primary btn-block py-2'
                onClick={handleSubmit}
                disabled={tenantLoading || submitting || activeTenant === null}>
                {tenantLoading ? <div class='spinner-border spinner-border-sm'></div> : "Authorize"}
              </button>
            </>
            {error && <div class='alert alert-danger mt-2'>{error}</div>}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
